/* eslint-disable import-x/order */
import 'virtual:uno.css'
import '@policyfly/components/styles.css'

import { createApp } from 'vue'

import { pinia } from './plugins/pinia'
import { vuetify } from './plugins/vuetify'

import App from './App.vue'
import { router } from './router'

const app = createApp(App)

app.use(router)
app.use(pinia)
app.use(vuetify)
app.mount('#app')
